export default __webpack_public_path__ + "static/media/feature4.6d8714cc.svg";